import { CompanyConfig, TimeFormat } from '../interface';

export const OkieConfig: CompanyConfig = {
  id: '11f1cb17-bea9-477a-b921-5a0fd7e7fa36',
  lang: 'en',
  langs: ['en', 'ar'],
  name: 'Jam Now',
  nameSecondary: 'JamNow',
  currency: 'AED',
  officialName: 'Jam Now',
  email: 'support@okieglobal.com',
  feedbackEmail: 'support@okieglobal.com',
  marketingEmail: 'support@okieglobal.com',
  phonePlaceholder: '+971',
  defaultPhoneCode: '+971',
  phoneNumber: '+971 586 616 977',
  ageRestricted: 21,
  timeZone: 'Asia/Dubai',
  minimalOrderFeeThreshold: 700,
  address:
    'Building A1, Dubai Digital Park, Dubai Silicon Oasis, Dubai, United Arab Emirates',
  canonical: '',
  defaultVolumeDisplay: '1x',
  warehouse: {
    default: 'DUBA',
    minimalOrderFeeWarehouseCodes: [],
    location: {
      lat: 25.124829662075868,
      lng: 55.38072780181319,
    },
  },
  map: {
    center: { lat: 25.124829662075868, lng: 55.38072780181319 },
    zoom: 12,
  },
  paymentMethods: ['cash', 'gpay', 'applepay', 'visa'],
  timeFormat: TimeFormat.h24,
  links: {
    cookie: '',
    deliveryZones: '',
    forRiders: '',
    whatsapp: '',
    facebook: '',
    instagram: '',
    tiktok: '',
    youtube: '',
    linkedin: '',
    affiliateProgram: import.meta.env.REACT_APP_AFFILIATE_PROGRAM_LINK,
    blog: '',
    legals: {
      cookiePolicy: {
        label: 'cookiePolicy',
        link: '/legals#cookie-policy',
        // link: 'https://s3.me-central-1.amazonaws.com/catalog.citydrinks.com/CD+Documents/Website+policies/Cookie+Policy.pdf',
      },
      paymentAndDeliveryPolicy: {
        label: 'paymentAndDeliveryPolicy',
        link: '/legals#payment-and-delivery',
        // link: 'https://s3.me-central-1.amazonaws.com/catalog.citydrinks.com/CD+Documents/Website+policies/Payment+%26+Delivery+Terms.pdf',
      },
      privacyPolicy: {
        label: 'privacyPolicy',
        link: '/legals#privacy-policy',
        // link: 'https://docs.google.com/document/d/1sqEMzpxEw58v51RXxcFXJHC2TSOhG3iC0mXBMLfk2QM',
      },
      salesAndReturnPolicy: {
        label: 'salesAndReturnPolicy',
        link: '/legals#sales-and-returns-policies-and-consumer',
        // link: 'https://s3.me-central-1.amazonaws.com/catalog.citydrinks.com/CD+Documents/Website+policies/Sales+%26+Return+Policy.pdf',
      },
      generalTradingPolicy: {
        label: 'generalTradingPolicy',
        link: '/legals#terms-of-service',
        // link: 'https://s3.me-central-1.amazonaws.com/catalog.citydrinks.com/CD+Documents/Website+policies/Terms+%26+Conditions.pdf',
      },
    },

    // https://jiffygrocery.atlassian.net/browse/JS-1854 -- requires to delete this links.
    // I will keep them commented for a while in case of customer change their mind
    // {
    //   label: 'tradeLicense',
    //   link: 'https://s3.me-central-1.amazonaws.com/catalog.citydrinks.com/CD+Documents/Website+policies/Trade+License+CD+General.pdf',
    // },
    // {
    //   label: 'trnCertificates',
    //   link: 'https://s3.me-central-1.amazonaws.com/catalog.citydrinks.com/CD+Documents/Website+policies/TRN+Certificate_CD+General.pdf',
    // },
  },
  referral: {
    code: 'SWIFFTUCDAVIS',
    discount: '15%',
    minBasket: '15',
    downloadAppLink: 'https://click.jiffy.shop/PZKk/f11c621',
  },
  points: {
    value: '1=1c.',
    pointsPerUnit: 15,
    icon: 'coins',
  },
  appStoreUrl: {
    ios: '',
    android: '',
  },
  apis: {
    yaMetrika: {
      token: 96706507,
    },
  },
  countryCode: 'AE',
  license: {
    name: 'HAXPORTE BRIDGE - FZCO',
    numberPrinary: '',
    numberSecondary: '',
  },
};
